import ajax from '../../../utils/ajax';
import { FollowUrlResponse } from '../../types';
import type { RecaptchaWrapper } from '../../../utils/createRecaptchaWrapper';
import type ResponseHandlerRetriever from './ResponseHandlerRetriever';

const wrapper = (responseHandlerRetriever: ResponseHandlerRetriever) => ({

  handle: async (res: FollowUrlResponse, recaptcha: RecaptchaWrapper) => {
    let current = res;
    const initialResponseType = res.type;
    let i = 0;

    while (current.type == initialResponseType) {
      if (++i > 10) { // safety valve
        throw new Error();
      }

      if (current.delayMilliseconds > 0) {
        await new Promise((resolve) => setTimeout(resolve, current.delayMilliseconds));
      }

      current = await ajax.get(current.url);
    }

    const handler = responseHandlerRetriever.get(current);

    return await handler.handle(current, recaptcha);
  },
});

export default wrapper;
